import _ from "lodash";
import React, { useContext, useState } from "react";
import { createUseStyles } from "react-jss";
import { Button } from "../../../components/common/Button";
import jssVariables from "../../../jss_setup";
import { modalGenericStyles } from "../../../jss_setup/modals";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import { InputField } from "../../../components/forms/inputGroup";
import { useAuth0 } from "@auth0/auth0-react";
import { updateGuestProfile } from "../../../api";
import { InlineIcon } from "@iconify/react";
import { toast } from "react-toastify";
import { profileErrorMsgs } from "../../../errors";

function validateForm({ values, t }) {
  var errors = [];
  if (!values.first_name) {
    errors.push("firstName");
  }
  if (!values.last_name) {
    errors.push("lastName");
  }
  if (!values.email) {
    errors.push("email");
  }
  if (errors.length) {
    toast.warning(
      <div>
        <strong>{profileErrorMsgs.general.emptyFields}</strong>
        <ul>
          {errors.map((msg, idx) => (
            <li key={idx}>{t(msg)}</li>
          ))}
        </ul>
      </div>,
      { duration: 5000 }
    );
  }
  return errors;
}

const profileStyles = createUseStyles({
  ...modalGenericStyles,
  EditProfileModal: (props) => ({
    ...modalGenericStyles.modal,
    display: "grid",
    justifyItems: "center",
    alignContent: "center",
    ..._.get(props, "customStyles.EditProfileModal", {}),
  }),
  modal: (props) => ({
    width: "90vw",
    background: jssVariables.colors.background.light,
    borderRadius: jssVariables.border_radius,
    padding: jssVariables.double_gap,
    ..._.get(props, "customStyles.modal", {}),
  }),
  header: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.header", {}),
  }),
  form: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    paddingTop: jssVariables.normal_gap,
    ..._.get(props, "customStyles.form", {}),
  }),
  actions: (props) => ({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: jssVariables.normal_gap,
    paddingTop: jssVariables.double_gap,
    ..._.get(props, "customStyles.actions", {}),
  }),
  loaderIconContr: (props) => ({
    width: "100%",
    textAlign: "center",
    height: "10rem",
    paddingTop: "3rem",
    ..._.get(props, "customStyles.loaderIconContr", {}),
  }),
  loaderIcon: (props) => ({
    fontSize: "xx-large",
    color: jssVariables.colors.base_color,
    ..._.get(props, "customStyles.loaderIcon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    EditProfileModal: (props) => ({
      alignContent: "baseline",
      ..._.get(props, "customStyles.EditProfileModal.smallscreen", {}),
    }),
    modal: (props) => ({
      width: "25rem",
      transform: "translateY(20%)",

      ..._.get(props, "customStyles.modal.smallscreen", {}),
    }),
  },
});
const EditProfileModal = ({ profile, getGuest, setShowEditModal }) => {
  const [loadingUpdProfile, setLoadingUpdProfile] = useState(false);

  const { t } = useContext(TranslationContext);
  const { user } = useAuth0();
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({
    type,
    brand,
    objName: "EditProfileModal",
  });

  const classes = profileStyles(customStyles);

  const onUpdateProfile = async (payload) => {
    setLoadingUpdProfile(true);
    const result = await updateGuestProfile({
      user_id: profile.ext_user_id,
      payload,
    });
    if (result) {
      await getGuest(profile.ext_user_id);
      setLoadingUpdProfile(false);
      setShowEditModal(false);
      return true;
    } else {
      toast.warning(<strong>{profileErrorMsgs.general.apiCallError}</strong>, {
        duration: 5000,
      });
      setLoadingUpdProfile(false);
      return false;
    }
  };

  return (
    <div className={classes.EditProfileModal}>
      <div className={classes.modal}>
        <div className={classes.header}>{t("editProfile")}</div>
        <Formik
          validateOnMount={false}
          validateOnChange={false}
          validateOnBlur={false}
          initialValues={{
            first_name: _.get(profile, "first_name", ""),
            last_name: _.get(profile, "last_name", ""),
            phone: _.get(profile, "phone", ""),
            email: _.get(user, "email", ""),
          }}
          validate={(values) => {
            return validateForm({ values, t });
          }}
          onSubmit={async (values) => {
            onUpdateProfile(values);
          }}>
          {loadingUpdProfile ? (
            <div className={classes.loaderIconContr}>
              <InlineIcon
                icon="eos-icons:loading"
                className={classes.loaderIcon}
              />
            </div>
          ) : (
            <Form className={classes.form}>
              <InputField
                label={t("firstName")}
                name="first_name"
                placeholder="----"
                noTranslInLabel={true}
                isRequired={true}
                customStyles={{}}
              />
              <InputField
                label={t("lastName")}
                name="last_name"
                placeholder="----"
                noTranslInLabel={true}
                isRequired={true}
                customStyles={{}}
              />
              {/* <InputField */}
              {/*   label={t("phone")} */}
              {/*   name="phone" */}
              {/*   placeholder="----" */}
              {/*   noTranslInLabel={true} */}
              {/*   customStyles={{}} */}
              {/* /> */}
              <InputField
                label={t("email")}
                name="email"
                placeholder="----"
                noTranslInLabel={true}
                disabled={true}
                customStyles={{}}
              />
              <div className={classes.actions}>
                <Button
                  text={t("cancel")}
                  onClick={() => setShowEditModal(false)}
                  bold={true}
                  empty={true}
                  revert={true}
                  size="small"
                  customStyles={{
                    ButtonReverted: {
                      ..._.get(customStyles, "btnStyles", {}),
                      height: "100%",
                    },
                  }}
                />
                <Button
                  type="submit"
                  text={t("save")}
                  bold={true}
                  size="small"
                  customStyles={{
                    ButtonDefault: {
                      ..._.get(customStyles, "btnStyles", {}),
                      height: "100%",
                    },
                  }}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
EditProfileModal.propTypes = {
  profile: PropTypes.object.isRequired,
  getGuest: PropTypes.func.isRequired,
  setShowEditModal: PropTypes.func.isRequired,
};
export default EditProfileModal;
